import axiosClient from '@services/api';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';

import IPaginatedesponse from '@models/paginated-reponse';
import Store from '@models/Store';

export const getStores = async (): Promise<
  AxiosResponse<IPaginatedesponse<Store>>
> => {
  return await axiosClient.get(EndPoints.Stores.getAll);
};
